import { Badge, BadgeProps } from '@/components/badge';
import { Tooltip } from '@/components/tooltip';
import { DELAY_STATUS } from '@/lib/constants';
import { ShipmentModel } from '@/lib/models/shipment/types';
import { getShipmentEtaStatus } from '@/utils/shipments';

import { ShipmentEtaTooltip } from '../eta-tooltip';

export interface ShipmentEtaBadgeProps {
  delay: ShipmentModel['delay'];
  modeType?: ShipmentModel['type'];
  eta?: ShipmentModel['eta'];
  originalEta?: ShipmentModel['originalEta'];
  showOnTime?: boolean;
}

const ShipmentEtaBadge = ({ delay, modeType, eta, originalEta, showOnTime }: ShipmentEtaBadgeProps) => {
  const status = getShipmentEtaStatus(delay, modeType);

  let badgeVariant: BadgeProps['variant'] = 'positive';
  let badgeText = showOnTime ? 'On time' : 'ETA';

  if (status === DELAY_STATUS.DELAYED) {
    badgeVariant = 'negative';
    badgeText = 'Delayed';
  }

  if (status === DELAY_STATUS.AHEAD) {
    badgeVariant = 'alert';
    badgeText = 'Ahead';
  }

  return (
    <Tooltip
      content={<ShipmentEtaTooltip status={status} delay={delay} eta={eta} originalEta={originalEta} />}
      followCursor="horizontal"
    >
      <div className="flex cursor-default">
        <Badge variant={badgeVariant}>{badgeText}</Badge>
      </div>
    </Tooltip>
  );
};

export { ShipmentEtaBadge };
